"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TangleAbilityHandler = exports.TangleActorAbilityFactory = exports.TangleAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class TangleAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Tangle;
        this.__typeName = "Tangle";
    }
}
exports.TangleAbilityArgs = TangleAbilityArgs;
let TangleActorAbilityFactory = class TangleActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Tangle", "OneEnemies", 2);
    }
};
TangleActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Tangle")
], TangleActorAbilityFactory);
exports.TangleActorAbilityFactory = TangleActorAbilityFactory;
let TangleAbilityHandler = class TangleAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Nature", 70)
            ],
            onHit(sequence) {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet"), "EntanglingRootsAssault"));
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new core_1.SlowEffectArgs(2),
                    duration: Duration_1.Duration.Turns(2),
                    sequence
                });
            }
        });
    }
};
TangleAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Tangle)
], TangleAbilityHandler);
exports.TangleAbilityHandler = TangleAbilityHandler;
